import { useTranslation } from "react-i18next";
import { Search, Layers, Users, UserCheck, ArrowRight } from "lucide-react";

export default function HowItWorks() {
  const { t } = useTranslation("landing");

  const steps = [
    {
      icon: Search,
      title: t("howItWorks.steps.0.title"),
      body: t("howItWorks.steps.0.body"),
    },
    {
      icon: Layers,
      title: t("howItWorks.steps.1.title"),
      body: t("howItWorks.steps.1.body"),
    },
    {
      icon: Users,
      title: t("howItWorks.steps.2.title"),
      body: t("howItWorks.steps.2.body"),
    },
    {
      icon: UserCheck,
      title: t("howItWorks.steps.3.title"),
      body: t("howItWorks.steps.3.body"),
    },
  ];

  // Load outcomes as array
  const outcomes = t("howItWorks.outcomes", { returnObjects: true }) as string[] || [];

  return (
    <section id="journey" className="scroll-mt-20 lg:scroll-mt-24 bg-soft-grad py-24 w-full">
      <div className="mx-auto w-full max-w-7xl px-4 sm:px-6 lg:px-8">
        <div className="text-center w-full">
          <p className="label-eyebrow">{t("howItWorks.tag")}</p>
          <h2 className="mt-3 text-4xl font-bold text-navy sm:text-[42px]">{t("howItWorks.title")}</h2>
        </div>

        <div className="mt-14 w-full grid grid-cols-1 gap-4 sm:grid-cols-2 lg:grid-cols-4 lg:gap-8">
          {steps.map((s, i) => (
            <div key={i} className="relative group">
              <div className="h-full rounded-2xl border border-border bg-white p-6 shadow-soft transition-all hover:-translate-y-1 hover:shadow-lg hover:border-primary/30">
                <div className="flex items-center gap-3">
                  <span className="grid h-10 w-10 place-items-center rounded-xl bg-blue-bg text-primary font-bold transition-colors group-hover:bg-primary group-hover:text-white">
                    {i + 1}
                  </span>
                  <s.icon className="h-5 w-5 text-primary" />
                </div>
                <h3 className="mt-5 text-base font-bold text-navy">{s.title}</h3>
                <p className="mt-2 text-sm leading-relaxed text-slate-body">{s.body}</p>
              </div>
              {i < steps.length - 1 && (
                <div className="absolute right-0 top-1/2 z-10 hidden h-10 w-10 -translate-y-1/2 translate-x-[calc(50%+16px)] place-items-center rounded-full bg-white border border-slate-100 shadow-md lg:grid">
                  <ArrowRight className="h-5 w-5 text-primary" strokeWidth={2.5} />
                </div>
              )}
            </div>
          ))}
        </div>

        <div className="mt-12 flex flex-wrap justify-center gap-3">
          {outcomes.map((o) => (
            <span
              key={o}
              className="rounded-full bg-white px-4 py-2 text-sm font-semibold text-navy ring-1 ring-border"
            >
              {o}
            </span>
          ))}
        </div>
      </div>
    </section>
  );
}
